// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","page":"page_page__-pCTU"};